module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hWsCV"))).then(() => parcelRequire('d0iPb'));